// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PieChartWidget_wrap__p9xDG","title":"PieChartWidget_title__2Sy26","inline":"PieChartWidget_inline__3rRN7"};